<template>
    <div class="product-selections">
        <div class="size-picker">
            <label>Size</label>
            <ProductSizes :isOpen="false" :isPicker="true" v-on="$listeners" />
        </div>
        <div>
            <label>Background</label>
            <Background />
        </div>
        <div v-if="!isCanvas">
            <label>Options</label>
            <Options />
        </div>
        <!--<div>
          <label title="Motif Count">Motifs</label>
          <router-link
            :class="[
              'picker',
              'no-arrow',
              { inactive: this.$route.name == 'Design' },
            ]"
            to="/motifs"
            :title="this.$route.name != 'Design' ? 'Go Back to Modify Design' : ''"
            >{{ productMotifs.length }}</router-link
          >
          <div></div>
        </div>-->
    </div>
</template>
<script>
    import Background from "@/components/Background.vue";
    import Options from "@/components/Options.vue";
    import ProductSizes from "@/components/ProductSizes.vue";
    import { mapState } from "vuex";
    import UserProduct from "../objects/UserProduct";
    export default {
        name: "ProductSelections",
        data() {
            return {
                active: false,
                hexColor: "",
            };
        },
        props: {
            isCanvas: {
                default: false,
                type: Boolean,
            },
        },
        computed: {
            ...mapState(["productInfo", "userProduct", "productMotifs"]),
        },
        destroyed() {
            // window.removeEventListener("resize", this.checkScrollState);
        },
        mounted() { },
        components: {
            ProductSizes,
            Background,
            Options,
        },
        methods: {},
    };
</script>
<style>
    .product-selections {
        display: flex;
        flex: 1 1 auto;
        -moz-column-gap: 1em;
        column-gap: 1em;
        justify-content: center;
        min-width: 17em;
    }

        .product-selections > div {
            text-align: center;
            width: calc(33.33% - .67em);
        }

        .product-selections label {
            font-size: 0.75em;
            text-transform: uppercase;
            line-height: 1.25rem;
        }

    .picker {
        position: relative;
        justify-content: center;
        border: none;
        width: 100%;
        height: 2em;
        display: flex;
        margin: 2px;
        border-radius: 3px;
        font-weight: bold;
        line-height: 2em;
        color: #666;
        text-decoration: none;
    }

        .picker:not(.inactive):hover {
            cursor: pointer;
        }

    .size-picker .picker {
        font-size: 1em;
        padding: 0;
        text-decoration: none;
        background: #fff;
        flex-flow: column;
        text-align: center;
    }

    .option-picker {
        background-size: auto 75%;
        background-position: 70% 50%;
        background-repeat: no-repeat;
        background-color: #fff;
    }

    .key-fob .option-picker {
        background-position: left center;
        background-size: auto 100%;
    }

    .color-picker {
        background-size: auto 100%;
        -ms-interpolation-mode: nearest-neighbor;
        image-rendering: -moz-crisp-edges;
        image-rendering: pixelated;
    }

    .picker::after {
        content: "\25BC";
        content: "\142F";
        position: absolute;
        font-size: .35rem;
        color: #333;
        right: 2px;
        top: 0;
        line-height: 2rem;
        /*! display: none; */
        transform: scaleX(1.5);
        /*! filter: drop-shadow(0 2px 0 #333); */
        background: #f0efef;
        padding: 0 2px;
        border-left: #fff solid 2px;
    }

    .picker::before {
        content: "";
        border-radius: 3px;
        position: absolute;
        border: solid 1px #ccc;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
    }

    .picker:not(.no-arrow):hover::after {
        display: block;
    }

    .picker:not(.inactive):hover::before {
        border-color: #666;
    }

    .picker.inactive {
        pointer-events: none;
    }

    .picker > span {
        display: none;
    }

    .product-selections .popup .popup-content {
        top: unset;
        transform: none;
        left: unset;
        padding: 0;
        z-index: 104;
        display: flex;
        flex-direction: column;
        max-height: calc(100vh - 12em);
        margin-top: .5em;
    }

    .product-selections .popup {
        position: unset;
    }

    .product-selections .overlay {
        z-index: 102;
        opacity: 0;
    }

    .product-selections .stop {
        z-index: 103;
        background: #fff;
        background: url('https://assets.needlepaint.com/images/belts-bg.jpg');
        background-size: cover;
        opacity: 1;
    }

    @media only screen and (max-width: 750px) {
        .product-selections .popup .popup-content {
            left: 0;
            right: 0;
            max-width: unset;
            width: 100%;
        }
    }

    .product-selections .size-picker .popup .popup-content {
        max-width: 928px;
    }

        .product-selections .size-picker .popup .popup-content .popup-scroll {
            flex-shrink: 1;
            overflow: auto;
            border-bottom: solid 1px #eee;
            padding: 0;
            margin-bottom: 1em;
        }

        .product-selections .size-picker .popup .popup-content .popup-static {
            padding: 0 1em;
        }
</style>
